import type {
    ListReviewsResponse,
    GoogleReview,
    GoogleReviewReplyInput,
    GoogleReviewReplySuggestionResult,
} from "./types"

export const GOOGLE_REVIEWS_FETCH_REQUESTED = "googleReviews/reviewsFetchRequested"
export const googleReviewsFetchRequested = (locationId: string) => ({
    type: GOOGLE_REVIEWS_FETCH_REQUESTED,
    payload: {
        locationId: locationId,
    },
})

export const GOOGLE_REVIEWS_FETCH_SUCCEEDED = "googleReviews/reviewsFetchSucceeded"
export const googleReviewsFetchSucceeded = (data: ListReviewsResponse) => ({
    type: GOOGLE_REVIEWS_FETCH_SUCCEEDED,
    payload: data,
})

export const GOOGLE_REVIEWS_FETCH_FAILED = "googleReviews/reviewsFetchFailed"
export const googleReviewsFetchFailed = (error: string) => ({
    type: GOOGLE_REVIEWS_FETCH_FAILED,
    payload: {
        error: error,
    },
})

export const GOOGLE_REVIEWS_PAGE_SELECTED = "googleReviews/pageSelected"
export const googleReviewsPageSelected = (pageNumber: number) => ({
    type: GOOGLE_REVIEWS_PAGE_SELECTED,
    payload: {
        pageNumber: pageNumber,
    },
})

export const GOOGLE_REVIEW_RESPONSE_PANEL_OPENED = "googleReviews/responsePanelOpened"
export const googleReviewResponsePanelOpened = (review: GoogleReview) => ({
    type: GOOGLE_REVIEW_RESPONSE_PANEL_OPENED,
    payload: {
        review: review,
    },
})

export const GOOGLE_REVIEW_RESPONSE_PANEL_CLOSED = "googleReviews/responsePanelClosed"
export const googleReviewResponsePanelClosed = () => ({
    type: GOOGLE_REVIEW_RESPONSE_PANEL_CLOSED,
})

export const GOOGLE_REVIEW_RESPONSE_SUBMIT_REQUESTED = "googleReviews/responseSubmitRequested"
export const googleReviewResponseSubmitRequested = (reviewId: string, locationId: string, message: string) => ({
    type: GOOGLE_REVIEW_RESPONSE_SUBMIT_REQUESTED,
    payload: {
        reviewId: reviewId,
        locationId: locationId,
        message: message,
    },
})

export const GOOGLE_REVIEW_RESPONSE_SUBMIT_SUCCEEDED = "googleReviews/responseSubmitSucceeded"
export const googleReviewResponseSubmitSucceeded = (
    reviewId: string,
    reply: { comment: string; updateTime: string }
) => ({
    type: GOOGLE_REVIEW_RESPONSE_SUBMIT_SUCCEEDED,
    payload: {
        reviewId: reviewId,
        reply: reply,
    },
})

export const GOOGLE_REVIEW_RESPONSE_SUBMIT_FAILED = "googleReviews/responseSubmitFailed"
export const googleReviewResponseSubmitFailed = (reviewId: string, error: string) => ({
    type: GOOGLE_REVIEW_RESPONSE_SUBMIT_FAILED,
    payload: {
        reviewId: reviewId,
        error: error,
    },
})

export const GOOGLE_REVIEW_RESPONSE_DELETE_REQUESTED = "googleReviews/responseDeleteRequested"
export const googleReviewResponseDeleteRequested = (reviewId: string, locationId: string) => ({
    type: GOOGLE_REVIEW_RESPONSE_DELETE_REQUESTED,
    payload: {
        reviewId: reviewId,
        locationId: locationId,
    },
})

export const GOOGLE_REVIEW_RESPONSE_DELETE_SUCCEEDED = "googleReviews/responseDeleteSucceeded"
export const googleReviewResponseDeleteSucceeded = (reviewId: string) => ({
    type: GOOGLE_REVIEW_RESPONSE_DELETE_SUCCEEDED,
    payload: {
        reviewId: reviewId,
    },
})

export const GOOGLE_REVIEW_RESPONSE_DELETE_FAILED = "googleReviews/responseDeleteFailed"
export const googleReviewResponseDeleteFailed = (reviewId: string, error: string) => ({
    type: GOOGLE_REVIEW_RESPONSE_DELETE_FAILED,
    payload: {
        reviewId: reviewId,
        error: error,
    },
})

export const GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_REQUESTED = "googleReviews/replySuggestionsFetchRequested"
export const googleReviewReplySuggestionsFetchRequested = (reviews: GoogleReviewReplyInput[]) => ({
    type: GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_REQUESTED,
    payload: {
        reviews: reviews,
    },
})

export const GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_SUCCEEDED = "googleReviews/replySuggestionsFetchSucceeded"
export const googleReviewReplySuggestionsFetchSucceeded = (results: GoogleReviewReplySuggestionResult[]) => ({
    type: GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_SUCCEEDED,
    payload: {
        results: results,
    },
})

export const GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_FAILED = "googleReviews/replySuggestionsFetchFailed"
export const googleReviewReplySuggestionsFetchFailed = (reviewIds: string[], error: string) => ({
    type: GOOGLE_REVIEW_REPLY_SUGGESTIONS_FETCH_FAILED,
    payload: {
        reviewIds: reviewIds,
        error: error,
    },
})

export const GOOGLE_REVIEW_REPLY_SUGGESTION_DISMISSED = "googleReviews/replySuggestionDismissed"
export const googleReviewReplySuggestionDismissed = (reviewId: string) => ({
    type: GOOGLE_REVIEW_REPLY_SUGGESTION_DISMISSED,
    payload: {
        reviewId: reviewId,
    },
})

export const GOOGLE_REVIEW_DRAFT_CHANGED = "googleReviews/draftChanged"
export const googleReviewDraftChanged = (reviewId: string, message: string) => ({
    type: GOOGLE_REVIEW_DRAFT_CHANGED,
    payload: {
        reviewId: reviewId,
        message: message,
    },
})
